
const monthShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const monthLong = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const dayShort = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const dayLong =  ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const formatDate = (date) => {
  let dateStr = `${dayShort[date.getDay()]}, ${monthShort[date.getMonth()]} ${date.getDate()}`;

  if (date.getFullYear() !== new Date().getFullYear()) {
    dateStr += `, ${date.getFullYear()}`;
  }
  return dateStr;
};

export default formatDate;

export {
  monthShort,
  monthLong,
  dayShort,
  dayLong
};
